import React, { Component, Fragment } from "react";
import { Form } from "react-bootstrap";
import LoadingProgressBar from "../spinners/LoadingProgressBar";
import $ from "jquery";
import AlertNoPermissionList from "../alerts/AlertNoPermissionList";

class ObjectHearingLoss extends Component {
    state = { noPermission: false, objectHearingLossList: null };

    getHearingLossList = async () => {
        const { fetchURL, onShowAlert, testType, defaultValue } = this.props;
        const passData = {
            testType: testType,
        };
        try {
            const response = await fetch(`${fetchURL}/get-hearing-loss-list`, {
                credentials: "include", //include - bez tego nie będą pojawiać się ciasteczka w przeglądarce
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(passData),
            });
            if (response.status === 200) {
                await response.json().then((fetchedData) => {
                    // //console.log(fetchedData);
                    if (fetchedData.status === "noPermission") this.setState({ noPermission: true, loading: false });
                    else if (fetchedData.status === false) onShowAlert({ variant: "danger", message: fetchedData.message });
                    else {
                        const hearingLossList = fetchedData.hearingLossList;
                        if (defaultValue === "all") {
                            hearingLossList.unshift({
                                key: 0,
                                value: "all",
                                text: "Wszystkie",
                            });
                        }
                        this.setState({ loading: false, objectHearingLossList: hearingLossList });
                    }
                });
            }
        } catch (err) {
            this.setState({ alert: { variant: "danger", message: "Nie udało się pobrać danych." } });
            setTimeout(this.getHearingLossList(), 4000);
        }
    };

    componentDidMount() {
        this.getHearingLossList();
    }

    render() {
        const { objectHearingLossList, noPermission, loading } = this.state;
        const { objectHearingLoss, req, classStyle, defaultValue, onSelectedHearingLoss } = this.props;
        return (
            <Fragment>
                <Fragment>
                    <Form.Label>Stopień niedosłuchu {req && <span className="required">*</span>}</Form.Label>

                    {noPermission ? (
                        <AlertNoPermissionList />
                    ) : loading || !objectHearingLossList ? (
                        <LoadingProgressBar />
                    ) : (
                        <Form.Control
                            as="select"
                            placeholder="Kliknij i wybierz"
                            custom
                            className={`form-dropdown mb-3 req ${classStyle}`}
                            onChange={(e) => {
                                onSelectedHearingLoss(e, e.target.value);
                            }}
                            onClick={() => $("#objectHearingLoss").removeClass("is-invalid")}
                            value={objectHearingLoss ? objectHearingLoss : defaultValue}
                            id="objectHearingLoss"
                        >
                            <option value="default">Kliknij i wybierz</option>
                            {objectHearingLossList.map((e, i) => (
                                <Fragment key={i}>
                                    <option value={e.value}>{e.text}</option>
                                </Fragment>
                            ))}
                        </Form.Control>
                    )}
                </Fragment>
            </Fragment>
        );
    }
}

export default ObjectHearingLoss;
